import {Fragment, useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {UpdateOrderComponent} from "../../component/UpdateOrderComponent";
import {BreadCrumb} from "../../component/Breadcrumb";
import {get} from "../../js/api";


export const UpdateOrder = ({}) => {

    const {orderId} = useParams();

    return (
        <Fragment>
            <UpdateOrderComponent identifier={orderId} token={false}></UpdateOrderComponent>
        </Fragment>
    );

};